import React from 'react';
import { Mail, Linkedin } from 'lucide-react';

const teamMembers = [
  {
    id: 1,
    name: 'Don McCann',
    image: 'https://customer-assets.emergentagent.com/job_aifirst-sme/artifacts/rdq1doec_1731317883576.jpeg',
    role: 'Founder & Sales Director',
    bio: '"With over 20 years of experience leading global development for major firms like Honeywell and Helvar, I bridge the gap between enterprise-grade strategy and SME agility. I help business owners implement the exact AI tools needed to scale without the corporate fluff."',
    email: 'don@happinessinaction.com',
    linkedin: '#',
  },
  {
    id: 2,
    name: 'Caroline Halpin',
    image: 'https://customer-assets.emergentagent.com/job_aifirst-sme/artifacts/yrqb3qhc_Caroline%20Pic.jpeg',
    role: 'Founder & Marketing Director',
    bio: '"With over 15 years of experience working with Google, I am an experienced marketer and business consultant. I specialise in turning complex digital strategies into clear, actionable plans that drive real growth. From SEO and paid media to brand positioning and AI-powered marketing automation, I help SMEs punch above their weight in competitive markets."',
    email: 'caroline@happinessinaction.com',
    linkedin: '#',
  },
];

const Team = () => {
  return (
    <section id="team" className="py-20 md:py-32">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[var(--accent-wash)] text-[var(--accent-text)] text-sm font-medium mb-4">
            Meet The Team
          </span>
          <h2 className="heading-2 mb-4">
            The Team Behind Your Transformation
          </h2>
          <p className="body-large">
            Industry veterans bringing enterprise expertise to SMEs.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className="card bg-white text-center flex flex-col items-center p-8"
            >
              {/* Avatar with Photo */}
              <div className="relative mb-6">
                <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-[var(--accent-primary)]">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Green dot indicator */}
                <div className="absolute bottom-2 right-2 w-4 h-4 rounded-full bg-[var(--accent-primary)] border-2 border-white" />
              </div>

              {/* Name & Role */}
              <h3 className="text-xl font-semibold text-[var(--text-primary)] mb-1">
                {member.name}
              </h3>
              <p className="text-[var(--accent-text)] font-medium mb-4">
                {member.role}
              </p>

              {/* Bio */}
              <p className="text-[var(--text-secondary)] text-sm leading-relaxed mb-6 flex-grow">
                {member.bio}
              </p>

              {/* Social Links - Centered and Symmetrical */}
              <div className="flex items-center justify-center gap-4 mt-auto">
                <a
                  href={`mailto:${member.email}`}
                  className="w-10 h-10 rounded-full bg-[var(--accent-wash)] flex items-center justify-center hover:bg-[var(--accent-primary)]/20 transition-colors"
                  aria-label={`Email ${member.name}`}
                >
                  <Mail className="w-5 h-5 text-[var(--accent-text)]" />
                </a>
                <a
                  href={member.linkedin}
                  className="w-10 h-10 rounded-full bg-[var(--accent-wash)] flex items-center justify-center hover:bg-[var(--accent-primary)]/20 transition-colors"
                  aria-label={`${member.name}'s LinkedIn`}
                >
                  <Linkedin className="w-5 h-5 text-[var(--accent-text)]" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
